export const categories = [
  {
    id: 'entertainment',
    name: '娱乐',
    description: '聚焦影视、音乐、综艺与演出市场的最新动态，带来轻松有料的文娱资讯。',
    icon: 'ri-film-line',
    tone: 'primary',
  },
  {
    id: 'celebrity',
    name: '明星动态',
    description: '追踪艺人公开行程、作品官宣与公益活动，第一时间了解台前幕后。',
    icon: 'ri-star-line',
    tone: 'accent',
  },
  {
    id: 'society',
    name: '社会',
    description: '关注城市生活、民生服务与公共空间的新变化，记录身边的真实故事。',
    icon: 'ri-building-2-line',
    tone: 'secondary',
  },
  {
    id: 'buzz',
    name: '网络热议',
    description: '盘点社交平台上被反复讨论的话题与新鲜玩法，看懂年轻人的兴趣风向。',
    icon: 'ri-fire-line',
    tone: 'primary',
  },
];